import React from 'react';
import { TextField } from '@mui/material';

interface LongTextFieldProps {
  value: string | null;
  onChange: (value: string | null) => void;
  autoFocus?: boolean;
  disabled?: boolean;
}

const LongTextField: React.FC<LongTextFieldProps> = ({ value, onChange, autoFocus, disabled }) => {
  return (
    <TextField
      variant="standard"
      fullWidth
      multiline
      minRows={1}
      value={value || ''}
      onChange={(e) => onChange(e.target.value || null)}
      autoFocus={autoFocus}
      disabled={disabled}
      sx={{
        '& .MuiInput-root': {
          fontSize: '1.125rem',
        },
        '& .MuiInput-input': {
          textAlign: 'center',
          p: 0,
        },
      }}
    />
  );
};

export default LongTextField;
